import type {
  FlagType,
  FlagValue,
} from '@/data-store/zustand/slices/globalSlice';

import { FEATURE_FLAGS } from './constants';

export function asStringListFlagValue(
  value: FlagValue | undefined
): string | string[] | undefined {
  if (typeof value === 'string' || Array.isArray(value)) return value;
  return undefined;
}

export function isTruthyFlagValue(value: FlagValue | undefined): boolean {
  return value === 'true';
}

export type PublicRetrofitEmailType = 'documents' | 'login';

/** Defaults to documents when the flag is missing or not 'true'. */
export function getPublicRetrofitEmailType(
  featureFlags: FlagType | undefined
): PublicRetrofitEmailType {
  if (
    isTruthyFlagValue(featureFlags?.[FEATURE_FLAGS.PUBLIC_RETROFIT_LOGIN_EMAIL])
  ) {
    return 'login';
  }
  return 'documents';
}

export function asStateRolloutPercents(
  value: FlagValue | undefined
): Record<string, number> | undefined {
  let parsed: unknown = value;
  if (typeof value === 'string') {
    try {
      parsed = JSON.parse(value);
    } catch {
      return undefined;
    }
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return undefined;
  }
  return parsed as Record<string, number>;
}

export function isInRollout(
  rolloutPercent: number,
  assignedBucketValue: number | undefined
): boolean {
  if (rolloutPercent <= 0) return false;
  if (rolloutPercent >= 100) return true;
  if (assignedBucketValue === undefined) return false;
  return assignedBucketValue < rolloutPercent;
}
